module.exports = __webpack_public_path__ + "static/media/phone-promoter.b36c05bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/phone-promoter.png
// module id = 346
// module chunks = 0